import { Link, useNavigate } from "react-router-dom";
import Layout2 from "../layouts/Layout2";
import { Helmet } from "react-helmet";
import TelegramLoginButtonComponent from "../components/TelegramLoginButton";
import '../App.css';

const Profile = () => {
    const navigate = useNavigate();
    
    const clearSession = (e) => {
        localStorage.removeItem("token");
        localStorage.removeItem('authenticated');
        localStorage.removeItem('frist_name');
        localStorage.removeItem('last_name');
        localStorage.removeItem('telegramAuthToken');
        navigate("/");
    };
    
    return (
        <Layout2 pageType={"Profile"}>
            <Helmet>
                <title>Profile</title>
            </Helmet>   
            <div className="profile-container">
                <div className="profile-telegram-section">
                    <TelegramLoginButtonComponent />
                </div>
                
                {
                    localStorage.getItem("authenticated") ? 
                        <div className="profile-menu">
                            <Link to={"/commission-payment"} className="profile-menu-item">
                                <i className="lni lni-wallet"></i>
                                <span className="profile-menu-text">ကော်မရှင် လက်ခံအကောင့်</span>
                            </Link>
                            <Link to={"/commission-withdrawl"} className="profile-menu-item">
                                <i className="lni lni-money-protection"></i>
                                <span className="profile-menu-text">ထုတ်ယူပြီး ကော်မရှင်</span>
                            </Link>
                            <a onClick={clearSession} className="profile-menu-item">
                                <i className="lni lni-exit"></i>
                                <span className="profile-menu-text">စနစ်မှထွက်မည်</span>
                            </a>
                        </div>
                    :
                        <div className="profile-instructions">
                            <h5>📱 Telegram ဖြင့် Login လမ်းညွှန်</h5>
                            <ul>
                                <li>Login in with Telegram Button အားနှိပ်ပါ</li>
                                <li>နိုင်ငံရွေးပြီး Telegram ဖုန်းနံပါတ် ထည့်ပါ</li>
                                <li>Telegram App ရှိ Telegram Chat တွင် Confirm Button အားနှိပ်ပါ</li>
                                <li>ပထမဆုံးအကြိမ် Login ဝင်ခြင်းအတွက် Telegram ဖုန်းနံပါတ်အား နိုင်ငံကုဒ်နှင့်တကွ ထပ်မံဖြည့်ပါ</li>
                                <li>အတည်ပြု Button အားနှိပ်ပါ</li>
                            </ul>
                        </div>    
                }
                
                <div className="profile-version">
                    Version 1.0.2
                </div>
            </div>
        </Layout2>
      );
}
 
export default Profile;